export default __webpack_public_path__ + "de55dc301288e6f3a63dce6b9b250fd1.png";